module.exports = __webpack_public_path__ + "img/linggekj_login_name@3x.a892fa58.png";